/* eslint-disable import/prefer-default-export */
// TODO: maybe using qs package to handle query string
import requests from '@webclient/lib/agent/requests';
import axiosApiInstance from '@webclient/lib/agent/services/api/axiosInstance';

import type {
  AIMatchBodyType,
  AIMatchResponseType,
} from '@webclient/shared-types/auth';
import { HistoryBlockByIdRequestType } from '@webclient/shared-types/search-result/history-blocks';
import {
  AskAIType,
  ConvertTextToSpeechRequestType,
  CreateAIThreadRequestType,
  GenerateIconsRequestType,
  GetAllThreadsParamsType,
  GetSpeakersRequestType,
  GetSpeakersResponseType,
} from '@webclient/shared-types/threads';

import qs from 'qs';

export const threads = {
  createOneThread: (body: CreateAIThreadRequestType) =>
    requests(axiosApiInstance).post<{ id: number; name: string }>(
      '/v1/entities/threads',
      body,
    ),
  askAI: (body: AskAIType) =>
    requests(axiosApiInstance).post('/v1/actions/ai/ask', body),
  getThreadById: <T>(id: string) =>
    requests(axiosApiInstance).get<T>(`/v1/entities/threads/${id}`),
  // TODO: rename. This method name is misleading (it gets a list, not a single item, and the ID is thread, not history block)
  getHistoryBlockById: <T>({
    id,
    ...restQuery
  }: HistoryBlockByIdRequestType) => {
    const stringifiedQuery = qs.stringify(restQuery);
    return requests(axiosApiInstance).get<T>(
      `/v1/entities/threads/${id}/history-blocks?${stringifiedQuery}`,
    );
  },
  getAIMatch: (body: AIMatchBodyType) =>
    requests(axiosApiInstance).post<AIMatchResponseType>(
      '/v1/actions/ai/match',
      body,
    ),
  getAll: <T>({ limit, order, page, type }: GetAllThreadsParamsType) =>
    requests(axiosApiInstance).get<T[]>(
      `/v1/entities/threads?page=${page}&limit=${limit}&order=${order}&type=${type}`,
    ),
  updateOneById: (id: string, body: { name: string }) =>
    requests(axiosApiInstance).patch(`/entities/threads/${id}`, body),
  convertTextToSpeech: (body: ConvertTextToSpeechRequestType) =>
    requests(axiosApiInstance).post('/v1/actions/ai/tts', body),
  getSpeakers: ({ threadId }: GetSpeakersRequestType) =>
    requests(axiosApiInstance).get<GetSpeakersResponseType>(
      `/v1/entities/threads/${threadId}/speakers`,
    ),
  generateIcons: (body: GenerateIconsRequestType) =>
    requests(axiosApiInstance).post('/v1/actions/image', body),
};
